module.exports = __webpack_public_path__ + "img/comite02.35f0b153.svg";